/* Private */
const getAttrFromNode = (contentNode, attr) => {
	if (!contentNode) {
		return null;
	}
	const attrToReturn = contentNode.marks.find((mark) => !!mark.attrs[attr]);
	return attrToReturn ? attrToReturn.attrs[attr] : null;
};

const traverseSelectionNodes = (contentRoot, styleAttrToGet) => {
	const content = contentRoot[0] ? contentRoot[0].content.content : contentRoot;
	const styleAttr = getAttrFromNode(content[0], styleAttrToGet);

	for (let i = 0; i < content.length; i++) {
		if (styleAttr !== getAttrFromNode(content[i], styleAttrToGet)) {
			console.log('contains_more_than_one_style');
			return 'contains_more_than_one_style';
		}
	}
	return styleAttr;
};

/* Public */

function getFontSize(editor) {
	const contentRoot = editor.view.state.selection.content().content.content;
	return traverseSelectionNodes(contentRoot, 'fontSize');
}

function getFontColor(editor) {
	const contentRoot = editor.view.state.selection.content().content.content;
	return traverseSelectionNodes(contentRoot, 'color');
}

const TiptapService = {
	getFontSize,
	getFontColor,
};

export default TiptapService;
